import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import LocationSearchResponse from "../LocationSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import Location from "../Location";


/**
 * @class LocationSearchResponseBase
 * @extends ModelBaseClass
 * @property {[Location]} locations
 * @property {number} totalItemCount (int64)
 */
class LocationSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[Location]} locations
	 */
	locations;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of LocationSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {LocationSearchResponse}
	 */
	static create(genericObject) {
		const newLocationSearchResponse = new LocationSearchResponse();
		newLocationSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newLocationSearchResponse;
	}

	/**
	 * Instantiates a new array of LocationSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[LocationSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newLocationSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newLocationSearchResponseArray.push(LocationSearchResponse.create(genericObject));
		});
		return newLocationSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('locations', '[Location]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default LocationSearchResponseBase;
